var showGoodsButton = true;

function freezeBody(enable) {
    var widthScroll = getWidthScroll();
    if (enable) {
        setTimeout(function () {
            $('.fader-page').show();
            $('body').css('overflow', 'hidden');
            $('body').css('padding-left', widthScroll + 'px');
        }, 100);

    } else {
        $('.fader-page').hide();
        $('body').css('overflow', 'auto');
        $('body').css('padding-left', 0);
    }
}

function getWidthScroll() {
    var div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';

    document.body.appendChild(div);
    var scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);

    return scrollWidth;
}

function initFilter() {
    $('.navisort-form').one('submit', function (e) {
        e.preventDefault();
        if ($('.mobile-subnavigagions-block:hidden').length > 0 ) {
            $('.mobile-subnavigagions-block:hidden input').attr('disabled', 'disabled');
        } else if ($('.desktop-subnavigagions-block:hidden').length > 0 ) {
            $('.desktop-subnavigagions-block:hidden input').attr('disabled', 'disabled');
        }
        $(this).submit();
        return false;
    });
    $('.hide-search-form').click(function () {
        var filters_block = $('.filters-block');
        if (filters_block.length > 0) {
            filters_block.css('left', '-320px');
            freezeBody(false);
        }
    });
    $('.js-show-filters-block').click(function () {
        var filters_block = $($(this).data('filters-block'));
        if (filters_block.length > 0) {
            $('.header-fixed').remove();
            filters_block.css('left', '0');
            freezeBody(true);
        }
    });

    $('.filters-block .show-goods__button').click(function () {
        $('#section-search-form').submit();
    });

    $('.show-goods__button').click(function () {
        if (typeof analytics != 'undefined') {
            var form = $(this).closest('form'),
                paramToName = {
                    available: 'В наличии',
                    preorder: 'Предзаказ',
                    wait: 'Ожидаются',
                    no: 'Нет в продаже'
                };
            if (form) {
                var formData = form.serializeArray(),
                    options = [];

                $.each(formData, function (key, item) {
                    if (paramToName.hasOwnProperty(item.name) && options.indexOf(paramToName[item.name]) === -1) {
                        options.push(paramToName[item.name]);
                    };
                });
                
                sendNavisortEvent(this, { eventType: 241, eventContent: options.join(', ') });
            }
        }
    });

    $('.js-b-search-pubhouse-input').on('focus', function () {
        var scrollPosition = document.querySelector('.block-pubhouse-bl-name').getBoundingClientRect().top;
        var filtersBlock = $('.filters-block__form');
        filtersBlock.animate({scrollTop: filtersBlock.scrollTop() + scrollPosition}, 500)
    });


    $('.menu-items-window-close').click(function () {
        $('.menu-open').removeClass("active");
        $('.menu-items').hide();
        navisortSwiper.init();
    });

    $('.js-genres-russianonly-check').change(function(){
        let $this = $(this),
            $form = $('#section-search-form');
        $form.find("input[name='russianonly']").prop('checked', $this.prop('checked'));
        $form.submit();
    });
    $(".reset-all-submit").click(function (e) {
        SectionSearch.reset();
        if ($('#section-search-form').length) {
            $('#section-search-form').submit();
        }
        else {
            clearSearchTxtNavisort();
            $('#catalog-navigation form').submit();
        }
    });
    var megabannerBeforeTop = 0;
    $(document).on('scroll', function () {
        var megabanner = document.querySelector('.megabanner');
        if (megabanner) {
            var boxMegabanner = megabanner.getBoundingClientRect();
            if (boxMegabanner.top < 350 && megabannerBeforeTop > boxMegabanner.top) {
                $('.megabanner__image').removeClass('megabanner-rotate');
            }
            else if (boxMegabanner.top > 500 && megabannerBeforeTop < boxMegabanner.top) {
                $('.megabanner__image').addClass('megabanner-rotate');
            }
            megabannerBeforeTop = boxMegabanner.top;
        }
    });

    var filtersBlockForm = $('.filters-block__form');
    var widthNoScroll = $('.filters-block__form .js-inner-width-scroll').width() - filtersBlockForm.width();
    filtersBlockForm.css('margin-right', widthNoScroll);

    navisortSwiper.init();

}

function afterReload() {
    SectionSearch.init();
    initFilter();
    freezeBody(false);
    $(window).trigger("scroll");
    var catalogBooks = $('.outer-catalog .products-row-outer, #wrapper-bottom .products-row-outer');
    catalogBooks.css('transition', '0');
    catalogBooks.css('opacity', '0.1');
    setTimeout(function () {
        catalogBooks.css('transition', '1s');
        catalogBooks.css('opacity', '1');
    }, 100);

    var inputSearch = document.querySelector('.navisort-find-text ');
    if (inputSearch) {
        setCaretPosition(inputSearch, inputSearch.value.length);
    }
}

$(function () {
    $(document).on("change", ".catalog-responsive .checkbox-ui input", function() {
        var is_checked = $(this).prop('checked');
        var other_inputs = $('.catalog-responsive .checkbox-ui input[name="' + $(this).prop('name') + '"]' +
            '[value="' + $(this).prop('value') + '"]');
        other_inputs.prop('checked', is_checked).parent().toggleClass("checked", this.checked);
    });

    if (typeof histlab != 'undefined') {
        var opts = {
            outer: ".outer-catalog",
            inner: ".inner-catalog",
            before: SectionSearch.hideQtip,
            callback: afterReload
        };

        if ($('.outer-catalog').length === 0) {
            opts.outer = "#right";
            opts.inner = "#right-inner";
            opts.secondOuterInner = [{outer: ".outer-catalog", inner: ".inner-catalog",}];
        }
        histlab.setOpts(opts);
    }

    $(document).on('click', '.content-block-tab-item:not(.content-block-tab-item-active)', function () {
        $('.js-content-block-tab').hide();
        $('span.content-block-tab-item-active').removeClass('content-block-tab-item-active');
        $(this).addClass('content-block-tab-item-active');
        $('.js-content-block-tab_' + $(this).data('tab')).show();
        $(document).trigger('scroll');
    });

    initFilter();
});

function updateSearchButton(form, data) {
    $('.goods-count').text(data.txt);
    $('.navisort-filter__goodscount').css('visibility', 'visible');
    if (data.count > 0) {
        $('.show-goods__button').attr('disabled', false).removeClass('show-goods__button_disabled');
    } else {
        $('.show-goods__button').attr('disabled', true).addClass('show-goods__button_disabled');
    }
}
